/**
 * Hands an already-authorized short-lived download URL to the browser.
 *
 * Authorization and archive construction occur on the backend; this helper
 * performs only the final user-agent navigation and does not fetch protected
 * bytes into application state.
 */
export function triggerBrowserDownload(url: string, filename?: string) {
  const anchor = document.createElement('a')
  anchor.href = url
  if (filename) anchor.download = filename
  anchor.click()
}
